/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $(document).foundation();
        $.localScroll({
          hash: false,
          lazy: true
        });
        $('#horaires-responsive-button, #horaires-button').click(function(){
          $item = $('#horaires');
          $item.parent().find('div').removeClass('active');
          $item.addClass('active');
        });
        $('#newsletter-button').click(function(){
          $item = $('#newsletter-responsive');
          $item.parent().find('div').removeClass('active');
          $item.addClass('active');
        });
        $('.home-header-slider').owlCarousel({
          items: 1,
          responsive:{
            0: {
              dots: false
            },
            1024: {
              dots: true
            }
          }
        });
        var now = moment().format('DD/MM/YYYY');
        $('.date').fdatepicker({
          // initialDate: now,
          language: 'fr',
          weekStart: 1,
          format: 'dd/mm/yyyy',
          disableDblClickSelection: true
        });

        function get_events($this, clear){
          status = $this.data('status');
          per_page = $this.data('per_page');
          cat = ( $this.data('cat') != null ) ? $this.data('cat') : cat;
          jQuery.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'get_ajax_events',
              category: cat,
              paged: paged,
              per_page: per_page,
              post_status: status
            },
            success: function(data, textStatus, XMLHttpRequest){
              data = $.parseJSON(data);
              if( clear ){
                $('#events-list').html('');
              }

              $('#events-list').append(data.html);
              if( !data.more ){
                 $('#more-events').hide();
              }else{
                 $('#more-events').show();
              }
            },
            error: function(MLHttpRequest, textStatus, errorThrown){
              alert(errorThrown);
            }
          });
        }

        var paged = 1;
        var cat = null;

        $('#more-events').click(function(){
          $this = $(this);
          paged++;
          get_events($this, false);
        });

        $('.events-category-item').click(function(){
          $this = $(this);

          if( !$this.hasClass('active') ){
            paged = 1;
            $('.events-category-item').removeClass('active');
            $this.addClass('active');
            get_events($this, true);
          }

        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
